import {DateTimeFormatter} from "js-joda";
import { Locale } from '@js-joda/locale_en-us';

export const REQUIRED_ERROR_MESSAGE = 'Required';
export const DATE_FORMATTER = DateTimeFormatter.ofPattern('dd MMMM YYYY').withLocale(Locale.US);
export const INTEGER_MAX = 2147483647; // 4 byte max
